import { Link } from "react-router-dom";
import { ArrowRight, Wrench } from "lucide-react";
import { careers } from "@/data/siteConfig";
import { CallButton } from "@/components/CallButton";
import { Reveal } from "@/components/Reveal";

export const CareersCTA = () => (
  <section className="bg-ink py-20 md:py-28" data-testid="careers-cta">
    <div className="mx-auto max-w-[1440px] px-5 md:px-8">
      <Reveal>
        <div className="relative overflow-hidden border border-gold/25 bg-gradient-to-br from-ink-surface to-ink p-8 md:p-14">
          <div className="blueprint-grid absolute inset-0 opacity-30" />
          <div className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-gold/10 blur-[100px]" />
          <div className="relative z-10 flex flex-col items-start justify-between gap-8 lg:flex-row lg:items-center">
            <div className="max-w-2xl">
              <div className="mb-5 flex items-center gap-3 font-heading text-xs font-bold uppercase tracking-[0.2em] text-gold">
                <Wrench className="h-4 w-4" /> Careers · Learn the Trade
              </div>
              <h2 className="font-heading text-3xl font-extrabold tracking-tight text-white sm:text-4xl">
                {careers.headline}
              </h2>
              <p className="mt-5 text-lg leading-relaxed text-steel">{careers.body}</p>
            </div>
            <div className="flex shrink-0 flex-col gap-3">
              <CallButton size="lg" showNumber testid="careers-call-btn" />
              <Link
                to="/careers"
                data-testid="careers-link"
                className="group inline-flex items-center justify-center gap-2 font-heading text-sm font-bold uppercase tracking-wide text-gold transition-colors hover:text-gold-soft"
              >
                Learn more
                <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
              </Link>
            </div>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
